import { useQuery } from '@tanstack/react-query';
import { invalidateAll } from '../../api/queryClient';
import { trpc, type RouterOutputs } from '../../api/trpc';

export type MergeJob = RouterOutputs['merge']['listJobs'][number];
export type MergeJobDetail = RouterOutputs['merge']['getJob'];
export type MergeTask = MergeJobDetail['tasks'][number];

const isActive = (status: string): boolean => status === 'queued' || status === 'running';

export function useMergeJobs(enabled = true) {
  return useQuery(
    trpc.merge.listJobs.queryOptions(undefined, {
      enabled,
      refetchInterval: (query) => (query.state.data?.some((j) => isActive(j.status)) ? 5000 : false),
    }),
  );
}

export function useMergeJob(id: number) {
  return useQuery(
    trpc.merge.getJob.queryOptions(
      { id },
      {
        enabled: Number.isFinite(id) && id > 0,
        refetchInterval: (query) => (isActive(query.state.data?.job.status ?? '') ? 3000 : false),
      },
    ),
  );
}

export function invalidateMerge(): Promise<void> {
  return invalidateAll(trpc.merge.pathFilter());
}
